(function () {
  const track = document.getElementById("slider-track");
  const dots = document.querySelectorAll(".gallery-dot");
  const imgs = document.querySelectorAll(".gallery-img");
  const prevBtn = document.getElementById("prev-btn");
  const nextBtn = document.getElementById("next-btn");
  const lightbox = document.getElementById("lightbox");
  const lbImg = document.getElementById("lb-img");
  const lbCounter = document.getElementById("lb-counter");
  const lbClose = document.getElementById("lb-close");
  const lbPrev = document.getElementById("lb-prev");
  const lbNext = document.getElementById("lb-next");
  const totalSlides =
    typeof wp_total_images !== "undefined" && wp_total_images > 0
      ? wp_total_images
      : window.product_data?.images?.length || imgs.length;
  let current = 0;
  let lbCurrent = 0;

  function goTo(i) {
    current = (i + totalSlides) % totalSlides;
    track.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, idx) =>
      d.classList.toggle("bg-teal-500", idx === current),
    );
    dots.forEach((d, idx) =>
      d.classList.toggle("bg-navy-900/20", idx !== current),
    );
  }
  prevBtn.onclick = () => goTo(current - 1);
  nextBtn.onclick = () => goTo(current + 1);
  dots.forEach((d) => (d.onclick = () => goTo(+d.dataset.index)));

  let startX = 0;
  track.addEventListener("touchstart", (e) => (startX = e.touches[0].clientX));
  track.addEventListener("touchend", (e) => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
  });

  function openLb(i) {
    lbCurrent = i;
    lbImg.src = imgs[i].src;
    lbCounter.textContent = `${i + 1} / ${totalSlides}`;
    lightbox.classList.remove("hidden");
    lightbox.classList.add("flex");
  }
  function closeLb() {
    lightbox.classList.add("hidden");
    lightbox.classList.remove("flex");
  }
  function lbNav(dir) {
    lbCurrent = (lbCurrent + dir + totalSlides) % totalSlides;
    lbImg.src = imgs[lbCurrent].src;
    lbCounter.textContent = `${lbCurrent + 1} / ${totalSlides}`;
  }

  imgs.forEach((img, i) => (img.onclick = () => openLb(i)));
  lbClose.onclick = closeLb;
  lbPrev.onclick = () => lbNav(-1);
  lbNext.onclick = () => lbNav(1);
  lightbox.onclick = (e) => {
    if (e.target === lightbox) closeLb();
  };
  document.addEventListener("keydown", (e) => {
    if (lightbox.classList.contains("hidden")) return;
    if (e.key === "Escape") closeLb();
    if (e.key === "ArrowLeft") lbNav(-1);
    if (e.key === "ArrowRight") lbNav(1);
  });

  let lbStartX = 0,
    lbStartY = 0;
  lbImg.addEventListener(
    "touchstart",
    (e) => {
      lbStartX = e.touches[0].clientX;
      lbStartY = e.touches[0].clientY;
    },
    { passive: true },
  );
  lbImg.addEventListener(
    "touchend",
    (e) => {
      const diffX = lbStartX - e.changedTouches[0].clientX;
      const diffY = lbStartY - e.changedTouches[0].clientY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        lbNav(diffX > 0 ? 1 : -1);
      } else if (diffY > 80) {
        closeLb();
      }
    },
    { passive: true },
  );
})();

(function () {
  const rvLightbox = document.getElementById("review-lightbox");
  const rvImg = document.getElementById("rv-img");
  const rvUser = document.getElementById("rv-user");
  const rvStars = document.getElementById("rv-stars");
  const rvCounter = document.getElementById("rv-counter");
  const rvBack = document.getElementById("rv-back");
  const rvPrev = document.getElementById("rv-prev");
  const rvNext = document.getElementById("rv-next");
  const rvCta = document.getElementById("rv-cta");
  const reviewImgs = document.querySelectorAll(".review-img");
  const rvTotal = reviewImgs.length;
  let rvCurrent = 0;
  let touchStartX = 0;
  let touchStartY = 0;

  function genStars(n) {
    let s = "";
    for (let i = 0; i < n; i++)
      s += '<i class="fas fa-star text-amber-400 text-xs"></i>';
    return s;
  }
  function openRvLb(i) {
    rvCurrent = i;
    const el = reviewImgs[i];
    const img = el.querySelector("img");
    rvImg.src = img.src;
    rvUser.textContent = el.dataset.user;
    rvStars.innerHTML = genStars(+el.dataset.rating);
    rvCounter.textContent = `${i + 1} / ${rvTotal}`;
    rvLightbox.classList.remove("hidden");
    rvLightbox.classList.add("flex");
  }
  function closeRvLb() {
    rvLightbox.classList.add("hidden");
    rvLightbox.classList.remove("flex");
  }
  function rvNav(dir) {
    rvCurrent = (rvCurrent + dir + rvTotal) % rvTotal;
    const el = reviewImgs[rvCurrent];
    const img = el.querySelector("img");
    rvImg.src = img.src;
    rvUser.textContent = el.dataset.user;
    rvStars.innerHTML = genStars(+el.dataset.rating);
    rvCounter.textContent = `${rvCurrent + 1} / ${rvTotal}`;
  }

  reviewImgs.forEach((el, i) => (el.onclick = () => openRvLb(i)));
  rvBack.onclick = closeRvLb;
  rvPrev.onclick = () => rvNav(-1);
  rvNext.onclick = () => rvNav(1);
  rvCta.onclick = closeRvLb;
  rvLightbox.onclick = (e) => {
    if (e.target === rvLightbox) closeRvLb();
  };
  rvLightbox.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  });
  rvLightbox.addEventListener("touchend", (e) => {
    const diffX = touchStartX - e.changedTouches[0].clientX;
    const diffY = touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY)) {
      rvNav(diffX > 0 ? 1 : -1);
    } else if (diffY < -80) {
      closeRvLb();
    }
  });
  document.addEventListener("keydown", (e) => {
    if (rvLightbox.classList.contains("hidden")) return;
    if (e.key === "Escape") closeRvLb();
    if (e.key === "ArrowLeft") rvNav(-1);
    if (e.key === "ArrowRight") rvNav(1);
  });
})();

function toggleFaq(btn) {
  const item = btn.parentElement;
  const content = item.querySelector(".faq-content");
  const wasActive = item.classList.contains("active");
  document.querySelectorAll(".faq-item").forEach((i) => {
    i.classList.remove("active");
    i.querySelector(".faq-content").classList.add("hidden");
  });
  if (!wasActive) {
    item.classList.add("active");
    content.classList.remove("hidden");
  }
}
